// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Block       = require("bs-platform/lib/js/block.js");
var Curry       = require("bs-platform/lib/js/curry.js");
var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var component = ReasonReact.reducerComponent("EventLayer");

function getTouchData(touchesType, $$event) {
  var touch = Curry._1(touchesType, $$event).item(0);
  return /* float array */[
          touch.screenX,
          touch.screenY,
          Date.now()
        ];
}

function getGesture(start_, end_) {
  var speedDown = (end_[/* y */1] - start_[/* y */1]) * 10000.0 / (end_[/* time */2] - start_[/* time */2]);
  var speedRight = (end_[/* x */0] - start_[/* x */0]) * 10000.0 / (end_[/* time */2] - start_[/* time */2]);
  var isHoriz = +(Math.abs(speedRight) > Math.abs(speedDown));
  var match_000 = +(Math.abs(speedRight) - 4000.0 > 0.0);
  var match_001 = +(speedRight > 0.0);
  var match_000$1 = +(Math.abs(speedDown) - 4000.0 > 0.0);
  var match_001$1 = +(speedDown > 0.0);
  if (isHoriz !== 0) {
    if (match_000 !== 0) {
      if (match_001 !== 0) {
        return /* Some */[/* Right */1];
      } else {
        return /* Some */[/* Left */0];
      }
    } else {
      return /* None */0;
    }
  } else if (match_000$1 !== 0) {
    if (match_001$1 !== 0) {
      return /* Some */[/* Down */3];
    } else {
      return /* Some */[/* Up */2];
    }
  } else {
    return /* None */0;
  }
}

function make(onAction, className, children) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (param) {
      var reduce = param[/* reduce */1];
      var tmp = {
        tabIndex: 0,
        onKeyDown: Curry._1(reduce, (function (e) {
                return /* KeyDown */Block.__(2, [e.which]);
              })),
        onTouchEnd: Curry._1(reduce, (function (e) {
                return /* TouchEnd */Block.__(1, [getTouchData((function (prim) {
                                  return prim.changedTouches;
                                }), e)]);
              })),
        onTouchMove: (function (e) {
            e.preventDefault();
            return /* () */0;
          }),
        onTouchStart: Curry._1(reduce, (function (e) {
                return /* TouchStart */Block.__(0, [getTouchData((function (prim) {
                                  return prim.targetTouches;
                                }), e)]);
              }))
      };
      if (className) {
        tmp.className = className[0];
      }
      return React.createElement("div", tmp, children);
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[/* touchStart : None */0];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      var match = state[/* touchStart */0];
      switch (action.tag | 0) {
        case 0 : 
            return /* Update */Block.__(0, [/* record */[/* touchStart : Some */[action[0]]]]);
        case 1 : 
            if (match) {
              var match$1 = getGesture(match[0], action[0]);
              if (match$1) {
                var direction = match$1[0];
                return /* UpdateWithSideEffects */Block.__(3, [
                          /* record */[/* touchStart : None */0],
                          (function () {
                              return Curry._1(onAction, direction);
                            })
                        ]);
              } else {
                return /* NoUpdate */0;
              }
            } else {
              return /* NoUpdate */0;
            }
            break;
        case 2 : 
            var switcher = action[0] - 37 | 0;
            if (switcher > 3 || switcher < 0) {
              return /* NoUpdate */0;
            } else {
              switch (switcher) {
                case 0 : 
                    return /* UpdateWithSideEffects */Block.__(3, [
                              /* record */[/* touchStart : None */0],
                              (function () {
                                  return Curry._1(onAction, /* Left */0);
                                })
                            ]);
                case 1 : 
                    return /* UpdateWithSideEffects */Block.__(3, [
                              /* record */[/* touchStart : None */0],
                              (function () {
                                  return Curry._1(onAction, /* Up */2);
                                })
                            ]);
                case 2 : 
                    return /* UpdateWithSideEffects */Block.__(3, [
                              /* record */[/* touchStart : None */0],
                              (function () {
                                  return Curry._1(onAction, /* Right */1);
                                })
                            ]);
                case 3 : 
                    return /* UpdateWithSideEffects */Block.__(3, [
                              /* record */[/* touchStart : None */0],
                              (function () {
                                  return Curry._1(onAction, /* Down */3);
                                })
                            ]);
                
              }
            }
            break;
        
      }
    });
  return newrecord;
}

exports.component    = component;
exports.getTouchData = getTouchData;
exports.getGesture   = getGesture;
exports.make         = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/EventLayer.re
// module id = 32
// module chunks = 0